import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ChecklistItem,
  ChecklistItemFilter,
  InteractionFilter,
  PageResponse,
} from '@app/models';
import { Observable } from 'rxjs';
import { BaseServiceClass } from './baseService.service';

@Injectable({ providedIn: 'root' })
export class ChecklistItemService extends BaseServiceClass<ChecklistItem> {
  constructor(protected httpService: HttpClient) {
    super(httpService, '/itenschecklists');
  }

  public updateItemsChecklist(items: ChecklistItem[]): Observable<any> {
    return this.httpService.patch(`${this.entity_url}/batch`, items);
  }

  filterWithChecklist(
    checklistItemFilter: ChecklistItemFilter,
    checklistId: number
  ) {
    if (!checklistItemFilter.linesPerPage) {
      checklistItemFilter.linesPerPage = 500;
    }

    let options = { params: <any>checklistItemFilter };
    return this.httpService.get<PageResponse<ChecklistItem>>(
      `${this.entity_url}/checklists/${checklistId}/filter`,
      options
    );
  }

  changeActive(checklistItemId: number, active: boolean) {
    return this.httpService.patch(
      `${this.entity_url}/active/${checklistItemId}/${active}`,
      null
    );
  }

  public getChecklistItemsByInteractionFilter(
    interactionFilter: InteractionFilter
  ): Observable<any[]> {
    interactionFilter.page = null;
    interactionFilter.orderBy = null;
    interactionFilter.linesPerPage = null;
    interactionFilter.direction = null;
    interactionFilter.grade = null;
    interactionFilter.gradeFinal = null;
    let options = { params: this.filterToParams(interactionFilter) };
    return this.httpService.get<any[]>(
      `${this.entity_url}/interactions`,
      options
    );
  }

  findBySegments(segments: any[]) {
    let options = { params: { segmentsIds: segments } };
    return this.httpService.get<any>(`${this.entity_url}`, options);
  }
}
